module.exports = __webpack_public_path__ + "media/FIVEx_tutorial_2.67910387.mp4";